import { resolveStorageUrl } from "../../utils/adminApiHelpers";
import { firstDefined, isPlainObject } from "../../utils/objectHelpers";

function resolveProductImage(item) {
  const full = item?.image_url;
  if (full != null && typeof full === "string" && full.trim()) {
    return full.trim();
  }
  return resolveStorageUrl(item?.image ? String(item.image) : "");
}

export function normalizeProductItem(raw) {
  if (!raw || typeof raw !== "object") return null;
  const item = isPlainObject(raw.attributes) ? raw.attributes : raw;
  const id = item.id ?? raw.id;
  if (id == null) return null;

  const str = (v) => (v == null ? "" : String(v));

  const nameObj = isPlainObject(item.name) ? item.name : null;
  const descObj = isPlainObject(item.description) ? item.description : null;

  const category = item.category;
  const categoryLabel =
    (category && (category.name_en || category.name_ar || category.name)) ||
    "";

  const featured =
    item.is_featured === 1 ||
    item.is_featured === true ||
    item.is_featured === "1";

  let galleryCount = 0;
  if (Array.isArray(item.gallery)) galleryCount = item.gallery.length;
  else if (typeof item.gallery_count === "number")
    galleryCount = item.gallery_count;

  return {
    id,
    name_ar: str(
      nameObj?.ar ??
        firstDefined(item, ["name_ar", "nameAr", "ar_name", "name_arabic"])
    ),
    name_en: str(
      nameObj?.en ??
        ((typeof item.name === "string" ? item.name : "") ||
          firstDefined(item, ["name_en", "nameEn", "en_name", "name_english"]))
    ),
    description_ar: str(
      descObj?.ar ??
        firstDefined(item, ["description_ar", "descriptionAr", "body_ar"])
    ),
    description_en: str(
      descObj?.en ??
        ((typeof item.description === "string" ? item.description : "") ||
          firstDefined(item, [
            "description_en",
            "descriptionEn",
            "body_en",
            "description",
          ]))
    ),
    category_id: item.category_id ?? category?.id ?? "",
    category_label: str(categoryLabel),
    image_url: resolveProductImage(item),
    is_featured: Boolean(featured),
    gallery_count: galleryCount,
  };
}
